import { useMutation, useQueryClient } from "@tanstack/react-query";
import { integrationService } from "../../../services/integrationService";
import type { Integration } from "../../../types";

export const useUpdateIntegration = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({
      integrationId,
      integration,
    }: {
      integrationId: string;
      integration: Partial<Integration>;
    }) => {
      const updated = await integrationService.patch(integrationId, integration);
      return { updated, integrationId };
    },
    onSuccess: ({ updated, integrationId }) => {
      qc.setQueryData(["integration", updated.id], updated);
      qc.invalidateQueries({ queryKey: ["integration", integrationId] });
      qc.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
